import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTES } from '@/lib/routes'

/** La raíz redirige al panel (el layout autenticado decide si pide login). */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: ROUTES.dashboard })
  },
})
